(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('userEdit', {
            parent: 'account',
            url: '/userEdit',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/users/users-form/users-form.html',
                    controller: 'UsersEditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                },
                user: null,
                canEditMail: true
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('userAdd');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
